<template>
    <section class="testimonials">
        <div data-aos="fade-up" data-aos-duration="1000" class="section-title">
            <h2>نظرات مشتریان</h2>
            <p>نظرات مشتریان در رابطه با خدمات رامنیک</p>
        </div>
        <swiper class="carousel" :options="swiperOption">
            <swiper-slide class="item" v-for="(testimonial,index) in testimonials" :key="index">
                <blockquote>
                    <font-awesome-icon icon="quote-left" />
                    <p>{{ testimonial.message }}</p>
                </blockquote>
                <div class="user">
                    <div class="img"
                         v-bind:style="{'background-image':'url(' + rootImagePath + testimonial.imagePath + ')'}"></div>
                    <label>{{ testimonial.fullName }}</label>
                </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
    </section>
</template>
<script>
    export default {
        props: {
            rootImagePath: {
                type: String
            },

            testimonials: {
                type: Array
            }
        },

        data()
        {
            return {
                swiperOption: {
                    slidesPerView: 1,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                    }
                }
            };
        }
    };
</script>
<style scoped>
    .testimonials {
        width: 100%;
        height: auto;
        float: left;
        direction: rtl;
        text-align: center;
        background: #fff;
    }

        .testimonials .carousel {
            width: 100%;
            margin-top: 10px;
        }

            .testimonials .carousel .item {
                width: 100%;
                padding: 0 15px;
            }

                .testimonials .carousel .item blockquote {
                    width: 100%;
                    min-height: 200px;
                    background: #ddd;
                    border-radius: 10px;
                    padding: 50px;
                    position: relative;
                    text-align: center;
                    font-size: 15px;
                }

                    .testimonials .carousel .item blockquote .fa-quote-left {
                        position: absolute;
                        top: 10px;
                        left: 10px;
                        font-size: 25px;
                        color: #292929;
                    }

                    .testimonials .carousel .item blockquote .fa-quote-right {
                        position: absolute;
                        bottom: 10px;
                        right: 10px;
                        font-size: 25px;
                        color: #292929;
                    }

                .testimonials .carousel .item .user {
                    width: 120px;
                    height: 160px;
                    color: #fff;
                    margin-left: auto;
                    margin-right: auto;
                    text-align: center;
                    margin-top: -90px;
                    position: relative;
                }

                    .testimonials .carousel .item .user .img {
                        width: 100px;
                        height: 100px;
                        border-radius: 50%;
                        margin-bottom: 10px;
                        background-position: center center;
                        background-size: cover;
                    }

    @media screen and (max-width: 1024px) {
        .testimonials .carousel .item {
            padding: 0 10px;
        }

            .testimonials .carousel .item blockquote {
                padding: 40px 30px 60px 30px;
                min-height: 300px;
                font-size:14px;
            }

                .testimonials .carousel .item blockquote .fa-quote-left,
                .testimonials .carousel .item blockquote .fa-quote-right {
                    font-size: 18px;
                }
    }

    .swiper-button-next,
    .swiper-button-prev {
        top: 100px !important;
    }
</style>
